<template>
    <v-row v-if="data">
        <v-col>
            <h3 class="pb-6" v-if="data.user.privilege">{{ $t('Очередь в категории') }} "{{ data.user.privilege.description }}"</h3>
            <h3 class="pb-6" v-else>{{ $t('Очередь в общем списке') }}</h3>
            <div class="page-inner mr-2" v-if="data">
                <ol class="my_list mb-9">
                    <li v-for="(item, itemKey) in data.raiting_number" :key="itemKey" :class="{'active': item.full_name == data.user.full_name}">{{ item.raiting }}. {{ item.full_name }}</li>
                </ol>
            </div>
        </v-col>
        <v-col>
            <h3 class="pb-6">{{ $t('История собеседования') }}</h3>
            <div class="page-inner">
                <v-card elevation="1" class="mb-6" v-for="(history, historyKey) in data.history" :key="historyKey">
                    <v-card-title>{{ history.status.name }}</v-card-title>
                    <v-card-subtitle v-if="history.ranging.order_date">{{ history.ranging.order_date }}</v-card-subtitle>
                    <v-card-text>
                        <div>{{ $t("Название компании") }}</div>
                        <div class="black--text mb-2">{{ history.company.name }}</div>

                        <div>{{ $t("Адрес компании") }}</div>
                        <div class="black--text mb-2">{{ history.company.full_address }}</div>

                        <div>{{ $t("Дата собеседования") }}</div>
                        <div class="black--text mb-2">{{ history.ranging.interview_date }}, {{ history.ranging.interview_time }}</div>

                        <div>{{ $t("Место собеседования") }}</div>
                        <div class="black--text mb-2">{{ history.ranging.address }}</div>

                        <div>{{ $t("Комментарий") }}</div>
                        <div class="black--text mb-2">{{ history.ranging.interview_comment }}</div>
                    </v-card-text>
                </v-card>
            </div>
        </v-col>
    </v-row>
</template>
<script>
    export default {
        props: {
            data: {
                default: null
            }
        },
        components: { 
        },
        mounted() {
            this.$emit('get-data');
        },
        data: () => ({
            
        }),
        methods: {
            
        },
        watch: {
			// $route() {
            //     this.getData();
            // }
            
        }
    }
</script>

<style>

</style>